import { useDiamondFilterAPI } from 'context/diamondFilterContext'
import { DiamondFilterAPIContextType } from 'types/diamondFilter.types'
import notFound from '@publicAssets/images/ui/404/diamond-not-found.png'
import Image from 'next/image'

const NoDiamondsMatched = () => {
  const { onResetFilters } =
    useDiamondFilterAPI() as DiamondFilterAPIContextType

  return (
    <div className="flex flex-col justify-center border-t md:pt-0 md:border-t-0 items-center text-sm md:text-base text-center min-h-[160px] md:min-h-[400px]">
      <div className="flex flex-nowrap justify-center mb-0 md:mb-6">
        <div>
          <span>
            No diamonds matched your search criteria... perhaps expand your
            search or
          </span>
          <a
            className="text-accent-9 underline hover:cursor-pointer ml-1"
            onClick={() => onResetFilters()}
          >
            reset your filters.
          </a>
          <span className="hidden md:inline-block relative top-2">
            <Image
              src={notFound}
              alt="diamond not found"
              width={32}
              height={24}
            />
          </span>
          <span className="relative top-1 md:hidden">
            <Image
              src={notFound}
              alt="diamond not found"
              width={20}
              height={14}
            />
          </span>
        </div>
      </div>
    </div>
  )
}

export default NoDiamondsMatched
